<template>
    <div>
        <div class="header">
            <h4>Announcements</h4>
            <div class="buttons">
                <el-button type="primary" @click="create" size="mini" icon="el-icon-plus" round :loading="loadingNew">New</el-button>
            </div>
        </div>

        <Table :items="announcements" :columns="columns" :actions="actions" :loading="loading.announcements" />

        <EditDialog :item="announcement" :isOpen="showEditDialog" :onClose="() => showEditDialog = false" />
    </div>
</template>

<script>
import { isEmpty, cloneDeep } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import Table from '@/components/Table';
import EditDialog from './AnnouncementsDialog';

export default {
    name: 'announcements',
    data() {
        return {
            columns: [
                {label: 'Title', prop: 'title'},
                { label: 'Draft?', formatter: (item) => (item.is_published_as_draft ? "✅" : "❌") },
                { label: 'Published?', formatter: (item) => (item.is_published ? "✅" : "❌") },
            ],
            actions: [
                { name: 'Edit', type: 'default', onClick: this.edit },
                { name: 'Toggle publish', type: 'primary', onClick: this.togglePublish },
                { name: 'Remove', type: 'danger', onClick: this.remove, requiresConfirm: true },
            ],

            announcement: {},
            showEditDialog: false,
            loadingNew: false
        };
    },
    components: {
        Table,
        EditDialog
    },
    mounted() {
        if (isEmpty(this.announcements)) this.getAnnouncements();
    },
    computed: mapGetters(['announcements', 'loading']),
    methods: {
        ...mapActions(['getAnnouncements']),
        edit(announcement) {
            this.announcement = cloneDeep(announcement);
            this.showEditDialog = true;
        },
        async create() {
            try {
                this.loadingNew = true
                const { data } = await this.$api.post('/product/announcements', {});
                this.edit(data);
                this.getAnnouncements();
            } catch (err) {
                this.$notify.error({ title: 'Failed creating a new announcement.' });
            } finally {
                this.loadingNew = false
            }
        },
        async togglePublish(announcement) {
            try {
                const isPublished = !announcement.is_published;
                const payload = { is_published: isPublished };
                await this.$api.put(`/product/announcements/${announcement.id}`, payload);
                this.getAnnouncements();
                this.$message.success(`The announcement has been ${isPublished ? '' : 'un'}published.`);
            } catch (err) {
                this.$notify.error({ title: 'Failed creating a new announcement.' });
            }
        },
        async remove(announcement) {
            try {
                await this.$api.delete(`/product/announcements/${announcement.id}`);
                this.$message.info('The announcement has been removed.');
                this.getAnnouncements();
            } catch (err) {
                this.$notify.error({
                    title: 'Couldn\'t remove announcement :(',
                    message: err.message
                });
            }

        }
    }
}
</script>

<style scoped>
.header {
    width: 100%;
    display: flex;
    align-items: center;
    margin: 10px 0;
}
h4 {
    margin-right: 10px;
}
</style>
